<div class="container-mentions">
  <div class="mentions">
    <h1 class="mentions__titre font-bold">MENTIONS LÉGALES ET CGU</h1>
  </div>
  <div class="proprietaire">
    <p class="proprietaire__editeur font-bold">
      Propriétaire et éditeur du site Meilleurtaux Santé :
    </p>

    <p class="proprietaire__marque marginParagraphe">
      marque exploitée par ACTIVE ASSURANCES SAS au capital de 30.000€ - RCS
      Paris - 527 496 699 - Société de courtage d'assurances immatriculée à
      l'ORIAS (orias.fr) sous le numéro 10058420 - CS 92459 - 75436 Paris CEDEX
      09. ACTIVE ASSURANCES a souscrit une garantie financière auprès de
      Groupama Assurance-Crédit & Caution S.A. et assurance de responsabilité
      civile professionnelle souscrite auprès de MMA IARD. Sous le contrôle de
      l'ACPR (Autorité de Contrôle Prudentiel et de Résolution - 4 place de
      Budapest, CS 92459, 75436 Paris Cedex 09).
    </p>

    <p class="proprietaire__directeur marginParagraphe">
      <span class="font-bold">Directeur de la publication</span>Monsieur Michael
      HORR, en qualité de Président de la société ACTIVE ASSURANCES.
    </p>

    <div class="hebergeur marginParagraphe">
      <p class="hebergeur__titre-hebergeur font-bold">Hébergeur</p>
      <p>
        Le prestataire assurant l’hébergement du site, ainsi que le stockage des
        informations, est OVH – SAS – 2 rue Kellermann 59100 Roubaix, inscrite
        au RCS de Roubaix au numéro B424 761 419 Téléphone : 08 203 203 63 n°
        indigo (0.118 €/min)
      </p>
    </div>

    <div class="definition marginParagraphe">
      <p class="definition__titre-definition font-bold">Définitions</p>

      <p class="definition__termes marginParagraphe">
        Les termes suivants désignent indifféremment : 
      </p>

      <div class="definition__liste_termes paddingLeft">
        <ul class="definition__liste__termes__ul">
          <li class="definition__liste__termes__ul__li">
            Société : ACTIVE ASSURANCES
          </li>
          <li class="definition__liste__termes__ul__li">
            Site : www.sante.meilleurtaux.com 
          </li>
          <li class="definition__liste__termes__ul__li">
            Utilisateur : Personne physique qui utilise les pages du site dans
            la perspective d’y obtenir un devis, un tarif ou acheter un produit
            d’assurance
          </li>
          <li class="definition__liste__termes__ul__li">
            Internaute : Toute personne physique ou morale qui se connecte au
            Site, qu’il soit Utilisateur ou autre
          </li>
          <li class="definition__liste__termes__ul__li">
            Partenaire : Entreprise tierce ou faisant partie du groupe
            Meilleurtaux, avec laquelle la Société entretient des relations
            commerciales dans le but d’apporter des services ou des informations
            complémentaires à l’Internaute.
          </li>
          <li class="definition__liste__termes__ul__li">
            Liens : Tout lien en direction du Site doit faire l’objet d’une
            autorisation préalable écrite. La société ACTIVE ASSURANCES décline
            toute responsabilité concernant le contenu de sites liés au Site et
            plus généralement du fait de ces liens.
          </li>
        </ul>
      </div>
    </div>

    <div class="objet marginParagraphe">
      <p class="objet__titre_objet font-bold">Objet du site</p>

      <p class="objet__description marginParagraphe">
        Le site sante.meilleurtaux.com permet à l’Utilisateur un accès gratuit
        aux services suivants :
      </p>

      <div class="objet__liste paddingLeft marginParagraphe">
        <ul class="objet__liste__ul">
          <li class="objet__liste__ul__li">
            Comparaison et affichage de tarification de contrats d’assurances
            correspondant au profil et aux besoins de l’Utilisateur
          </li>
          <li class="objet__liste__ul__li">
            Mise en relation directe avec ACTIVE ASSURANCES ou ses partenaires
            dans le cadre de la proposition d’offres d’assurances
          </li>
          <li class="objet__liste__ul__li">
            Mise à dispositions d’articles gratuits à destination de tous les
            utilisateurs  
          </li>
        </ul>
      </div>
    </div>

    <div class="copmletantFormulaire marginParagraphe">
      <p>
        En complétant le formulaire et en le validant, l’Internaute reconnait,
        avoir lu et accepté les conditions générales d’utilisation du site ainsi
        que les mentions légales. L’acceptation électronique des conditions
        générales d’utilisation constitue la preuve que l’Utilisateur a lu et a
        pris connaissance desdites dispositions et les acceptent. La version
        figurant en ligne sur le Site prévaut sur toute version de date
        antérieure.
      </p>

      <p class="marginParagraphe">
        Les services, et le contenu du Site sont exclusivement réservés à des
        personnes majeures et capables, résidant sur le territoire de la
        république française pour une utilisation personnelle et non commerciale
      </p>
    </div>

    <div class="fonctionnement-service">
      <p class="marginParagraphe font-bold">Fonctionnement du service</p>

      <p class="marginParagraphe">
        Le service est totalement gratuit pour l’Utilisateur. Les offres de
        produits comparées sur le Site s’affichent tous frais compris hors frais
        de dossier indiqués séparément dans le détail de l’offre proposée.
      </p>

      <p class="marginParagraphe">
        Les offres d’assurance sont classées par ordre de prix croissant, sauf
        volonté de l’Utilisateur de classer les résultats par ordre de prix
        décroissant.
      </p>

      <p class="marginParagraphe">
        Le Site compare, les offres de partenaires d’ACTIVE ASSURANCES en
        fonction de critères objectifs mais n’effectue pas une comparaison
        exhaustive de toutes les offres disponibles sur le marché objet de la
        demande de devis faite par l’Utilisateur.
      </p>

      <p class="marginParagraphe">
        L’utilisateur est informé qu’en l’absence de souscription immédiate du
        contrat d’assurance au tarif proposé, ce dernier n’est pas garanti dans
        le temps et pourra évoluer selon la politique tarifaire d’ACTIVE
        ASSURANCES et de ses partenaires.
      </p>

      <p class="marginParagraphe">
        Les offres restituées sur le Site peuvent ne pas correspondre à l’offre
        finale qui sera faite par le partenaire, en cas d’informations
        supplémentaires demandées et prises en compte lors de la souscription du
        contrat d’assurance, ou en cas de rectification de certaines
        informations par l’Utilisateur, la Société ne peut garantir l’identité
        de l’offre finale à celle visualisée sur le Site par l’Utilisateur. De
        même, la décision d’accorder l’assurance souhaitée dépend uniquement des
        conditions fixées par les partenaires d’ACTIVE ASSURANCES. ACTIVE
        ASSURANCES ne pourra donc être responsable d’un éventuel refus
        d’assurance de la part du partenaire, organisme ou distributeur
        d’assurance.
      </p>
    </div>

    <div class="declaration">
      <p class="marginParagraphe font-bold">Déclaration</p>

      <p class="marginParagraphe">
        L’Internaute se déclare averti et accepte expressément de manière libre
        et non équivoque qu’il peut être contacté par email ou bien par
        téléphone par un conseiller d’ACTIVE ASSURANCES pour faire le point sur
        sa demande de tarif, pour étudier ses besoins et recevoir des offres
        personnalisées.
      </p>

      <p class="marginParagraphe">
        Pour ne pas faire l’objet de prospection commerciale par voie
        téléphonique l’Internaute est informé qu’il peut s’inscrire gratuitement
        sur la liste d’opposition au démarchage téléphonique BLOCTEL. (<a
          href="https://www.bloctel.gouv.fr/"
          target="_blank"
          class="link-color"
          >www.bloctel.gouv.fr</a
        >). Dans ce cas, ACTIVE ASSURANCES ne procédera à aucun démarchage
        téléphonique, sauf si l’Utilisateur a communiqué son numéro de téléphone
        afin d’être recontacté ou s’il est titulaire auprès d’ACTIVE ASSURANCES
        d’un contrat en vigueur.
      </p>

      <p>En outre, l’Internaute est informé : </p>

      <div class="declaration__liste paddingLeft">
        <ul class="declaration__liste__ul">
          <li class="declaration__liste__ul__li">
            que les informations qu’il communique via les formulaires présents
            sur le Site sont nécessaires à l’exécution de la prestation offerte
            par la Société. Elles sont collectées par la Société pour permettre
            la recherche d’un contrat d’assurance adapté aux besoins de
            l’Utilisateur. Les informations fournies par les internautes
            pourront en outre, sous réserve de l’accord de l’Internaute
            concerné, être communiquées aux Partenaires de la Société.
            L’ensemble des informations demandées dans les formulaires ont un
            caractère obligatoire pour la réalisation de devis d’assurance.
            L’Utilisateur s’oblige à ne communiquer et à n’inscrire sur le Site
            que des informations véridiques, sincères, régulières et fidèles sur
            ses coordonnées, son activité et sur ses besoins.
          </li>
          <li class="declaration__liste__ul__li">
            l’Internaute est informé que des réponses erronées peuvent conduire
            à rendre caduc le contrat d’assurance souscrit.
          </li>
        </ul>
      </div>
    </div>

    <div class="responsablite">
      <p class="responsabilite__titre marginParagraphe font-bold">
        Responsabilité
      </p>

      <p class="responsabilite__internaute marginParagraphe">
        L’Internaute est informé que le Site est accessible 24h sur 24 et 7
        jours sur 7, à l’exception des cas de force majeure, difficultés
        informatiques ou difficultés des réseaux de télécommunications. Le Site
        peut ainsi subir des suspensions temporaires pour des raisons techniques
        liées à des mises à jour, à de la maintenance (y incluant la maintenance
        des serveurs d’hébergement) ou à toute autre cause technique.
      </p>

      <p class="responsabilite__societe marginParagraphe">
        La Société met tout en oeuvre pour offrir à l’Internaute des
        informations vérifiées, mais elle ne saurait être tenue pour responsable
        des erreurs ou d’une absence de disponibilité des informations contenues
        sur son Site, ni des dommages directs ou indirects pouvant en résulter.
      </p>

      <p class="responsabilite__meme_maniere marginParagraphe">
        De la même manière, la Société met tout en oeuvre pour offrir à
        l’Utilisateur des informations vérifiées mais elle ne saurait être tenue
        pour responsable de la qualité des informations ou plus généralement de
        toute fausse information sur les produits, services et/ou tarifs
        communiqués ou bien d’une absence de disponibilité de sa part.
      </p>

      <p class="responsabilite__utilisateur marginParagraphe">
        L’Utilisateur reconnaît être seul responsable du choix de contrat
        d’assurance, de la formule et de l’organisme assureur qui lui sera
        présenté sur le Site ou par téléphone. La Société ne pourra en aucun cas
        être tenue pour responsable de tout dommage direct ou indirect causé par
        la vente et/ou la réalisation de la prestation convenue à la suite de
        l’intermédiation. Il appartient à l’Utilisateur de vérifier les
        informations communiquées à la Société, via le Site, pour s’assurer de
        l’adéquation du conseil qui lui sera donné.
      </p>

      <p class="responsabilite__enfin marginParagraphe">
        Enfin, la Société met tout en oeuvre pour offrir à l’Internaute un Site
        sécurisé, notamment en matière d’absence de virus sur son Site. Il
        appartient cependant à l’Internaute de protéger son matériel ou réseau
        informatique en se dotant d’un anti-virus qui sera régulièrement mis à
        jour par l’Internaute. La Société ne pourra en aucun cas être tenue pour
        responsable d’une quelconque intrusion de virus dans le matériel
        informatique de l’Internaute, ni des dommages directs ou indirects
        pouvant en résulter.
      </p>

      <p class="responsabilite__par_ailleur marginParagraphe">
        Par ailleurs, les liens hypertextes mis en place dans le cadre du
        présent Site en direction d’autres ressources présentes sur le réseau
        Internet ne sauraient engager la responsabilité de la Société. Il
        appartiendra à l’Internaute de vérifier la qualité des informations
        communiquées sur ces autres plateformes, ainsi que leurs conditions
        générales d’utilisation.
      </p>
    </div>

    <div class="propriete_intellectuelle">
      <p class="propriete_intellectuelle__titre marginParagraphe font-bold">
        Propriété intellectuelle 
      </p>

      <p class="propriete_intellectuelle__element marginParagraphe">
        Les éléments du site www.sante.meilleurtaux.com , sa présentation, ses
        contenus tel que notamment les textes, images, photographies, vidéos,
        marques, logos et autres informations présentes sur le site sont la
        propriété d’ACTIVE ASSURANCES ou sont utilisées par cette dernière avec
        l’accord des titulaires des droits. Certaines images ou photos utilisées
        proviennent de banque d’images libres de droits.
      </p>

      <p class="propriete_intellectuelle__toute_reproduction marginParagraphe">
        Toute reproduction, modification, distribution partielle ou totale, par
        quelque moyen que ce soit, de ces éléments est interdite, sans
        l’autorisation écrite et préalable. Toute exploitation non autorisée du
        site ou de son contenu, des informations qui y sont divulguées
        engagerait la responsabilité de l’utilisateur et constituerait une
        contrefaçon sanctionnée notamment par les articles L.335-2 et suivants
        du Code de la Propriété Intellectuelle.
      </p>

      <p class="propriete_intellectuelle__enfin marginParagraphe">
        Enfin, l’Utilisateur est informé que le Site peut contenir des liens
        hypertextes renvoyant vers des sites Internet de tiers. A cet égard, la
        responsabilité du Site ne saurait être engagée dans le cas où le contenu
        des sites Internet accessibles via les liens présents sur le Site
        contreviendrait aux dispositions légales et règlementaires en vigueur.
      </p>
    </div>

    <div class="modification">
      <p class="modification__titre marginParagraphe font-bold">Modification</p>

      <p class="modification__description marginParagraphe">
        ACTIVE ASSURANCES se réserve le droit de modifier ou, de façon plus
        générale, d’actualiser les présentes mentions légales à tout moment.
        Toute nouvelle version des mentions légales sera portée à la
        connaissance de l’utilisateur et soumis à son acceptation préalable à
        l’occasion de sa connexion au Site.
      </p>
    </div>

    <div class="confidentialite">
      <p class="confidentialite__titre marginParagraphe font-bold">
        Confidentialité de données personnelles 
      </p>

      <p class="marginParagraphe">
        Les informations collectées au moyen du Site contiennent des données à
        caractère personnel au sens de la loi n°78-17 du 6 janvier 1978 modifiée
        ainsi que par le Règlement 2016/679 relatif à la protection des
        personnes physiques à l’égard du traitement des données à caractère
        personnel et à la libre circulation de ces données du 27 avril 2016
        (ci-après la « Réglementation »). 
      </p>

      <p class="marginParagraphe">
        La collecte des données à caractère personnel de l’Utilisateur est
        nécessaire pour la comparaison et l’affichage de tarification de
        contrats d’assurances correspondant au profil et au besoins de
        l’Utilisateur.
      </p>

      <div class="confidentialite__ainsi">
        <p class="marginParagraphe">
          Ainsi, ACTIVE ASSURANCES peut être amenés à collecter différentes
          catégories de données personnelles telle que :
        </p>

        <div class="confidentialite__ainsi__liste paddingLeft">
          <ul class="confidentialite__ainsi__liste__ul">
            <li class="confidentialite__ainsi__liste__ul__li">
              Les informations d’identification et de contact (nom, prénom, lieu
              et date de naissance, adresse postale et électronique, numéro de
              téléphone, sexe, âge) ; 
            </li>
            <li class="confidentialite__ainsi__liste__ul__li">
              Situation familiale et professionnelle (statut marital, nombre
              d’enfant à charge, catégorie socio professionnelle) ; 
            </li>
          </ul>
        </div>
      </div>

      <div class="confidentialite__en_cas marginParagraphe">
        <p>
          En cas de souscription d’un contrat d’assurance par l’intermédiaire
          d’ACTIVE ASSURANCES :
        </p>

        <div class="confidentialite__en_cas__liste paddingLeft">
          <ul class="confidentialite__en_cas__liste__ul">
            <li class="confidentialite__en_cas__liste__ul__li">
              Informations bancaires (Relevé d’Identité bancaire, Mandat de
              prélèvement SEPA).
            </li>
            <li class="confidentialite__en_cas__liste__ul__li">
              Numéro de Sécurité sociale ; 
            </li>
            <li class="confidentialite__en_cas__liste__ul__li">
              Données de santé (devis et factures de professionnels de santé,
              ordonnances médicales, radios, décomptes Sécurité sociales,
              certificats médicaux,). 
            </li>
            <li class="confidentialite__en_cas__liste__ul__li">
              Enregistrement téléphonique, pour des besoins de formation et dans
              le cadre des obligations légales d’ACTIVE ASSURANCES
            </li>
          </ul>
        </div>
      </div>

      <div class="confidentialite__finalites marginParagraphe">
        <p>
          Les finalités ayant pour base légale le consentement de l’Utilisateur
          sont : 
        </p>

        <div class="confidentialite__finalites__liste paddingLeft">
          <ul class="confidentialite__finalites__liste__ul">
            <li class="confidentialite__finalites__liste__ul__li">
              Prospection commerciale 
            </li>
            <li class="confidentialite__finalites__liste__ul__li">
              La fourniture de devis ;   
            </li>
            <li class="confidentialite__finalites__liste__ul__li">
              L’assistance de l’Utilisateur lors de demandes de souscription de
              produits d’assurance 
            </li>
          </ul>
        </div>
      </div>

      <div class="confidentialite__en_cas_de_souscription marginParagraphe">
        <p>
          En cas de souscription d’un contrat d’assurance par l’intermédiaire
          d’ACTIVE ASSURANCES les données personnelles de l’Utilisateur seront
          utilisées le cas échéant pour :
        </p>

        <div class="confidentialite__en_cas_de_souscription__liste paddingLeft">
          <ul class="confidentialite__en_cas_de_souscription__liste__ul">
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              La passation, la gestion et l’exécution de vos contrats
              d’assurance, la gestion des sinistres et l’indemnisation
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              La fourniture des informations relatives à un produit / contrat
              par lequel l’Utilisateur est couvert ; 
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              Le suivi de la relation client ;
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              Répondre à des obligations de conseil, pour proposer des offres
              commerciales d’ACTIVE ASSURANCES ou de ses partenaires compte tenu
              des besoins exprimés par l’Utilisateur.
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              Se conformer aux obligations légales, réglementaires et
              administratives (lutte contre le blanchiment de capitaux et le
              financement du terrorisme, lutte contre la fraude, protection de
              la clientèle, gestion des dossiers contentieux). 
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              La prospection commerciale pour des produits et des services
              analogues, 
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              Les données personnelles sont également recueillies afin de
              permettre à ACTIVE ASSURANCES de mesurer l’audience, l’utilisation
              ainsi que les performances du Site pour établir des statistiques
              anonymisées ainsi que des volumes de fréquentation. Ceci dans le
              but d’améliorer la qualité ainsi que l’ergonomie de nos services.
            </li>
            <li class="confidentialite__en_cas_de_souscription__liste__ul__li">
              Les bases légales de ces traitements de données sont l’exécution
              du contrat, l’intérêt légitime et le respect des obligations
              légales
            </li>
          </ul>
        </div>
      </div>

      <div class="confidentialite__afin_accomplir marginParagraphe">
        <p>
          Afin d’accomplir les finalités précitées, les destinataires des
          données sont les services d’ACTIVE ASSURANCES et toute autre personne
          intervenant au contrat ou dans la gestion d’un sinistre. Elles sont
          également susceptibles d’être traitées par :
        </p>

        <div class="confidentialite__afin_accomplir__liste paddingLeft">
          <ul class="confidentialite__afin_accomplir__liste__ul">
            <li class="confidentialite__afin_accomplir__liste__ul__li">
              Nos prestataires de services et sous-traitant réalisant des
              prestations pour notre compte ; 
            </li>
            <li class="confidentialite__afin_accomplir__liste__ul__li">
              Nos partenaires organisme d’assurances ou courtiers ; 
            </li>
            <li class="confidentialite__afin_accomplir__liste__ul__li">
              Les éventuels réassureurs ; 
            </li>
            <li class="confidentialite__afin_accomplir__liste__ul__li">
              Autorités financières, judiciaires ou agences d’Etat, organismes
              publics sur demande et dans la limite de ce qui est permis par la
              règlementation ; 
            </li>
            <li class="confidentialite__afin_accomplir__liste__ul__li">
              Certaines professions règlementées telles qu’avocats, commissaires
              aux comptes etc. 
            </li>
          </ul>
        </div>
      </div>

      <div class="confidentialite__en_cas_transfert">
        <p class="marginParagraphe">
          En cas de transfert hors de l’Union Européenne de données
          personnelles, des garanties sont prises pour assurer un bon niveau de
          protection de ces données. Elles seront uniquement communiquées aux
          destinataires qui ont besoin d’y avoir accès pour la réalisation de
          leur mission. Le transfert est limité aux pays listés par la
          Commission Européenne comme protégeant suffisamment les données ou aux
          destinataires respectant soit les clauses contractuelles types de la
          Commission Européenne soit des règles internes d’entreprise (BCR). 
        </p>

        <p class="marginParagraphe">
          En cas de devis et d’absence de conclusion d’un contrat, vos données
          sont conservées pendant un délai maximum de trois ans.
        </p>

        <p class="marginParagraphe">
          En cas de conclusion d’un contrat, la durée de conservation des
          données personnelles des Utilisateurs correspond à la plus longue des
          durées légales nécessaires au respect des finalités exposées ci-avant
          majorée du délai de prescription. 
        </p>

        <p class="marginParagraphe">
          L’Utilisateur dispose de l’ensemble des droits prévus par la loi
          informatique et libertés et notamment des droits d’accès, de
          suppression, rectification, d’effacement, de limitation du traitement,
          d’opposition, de portabilité, sur l’ensemble des données à caractère
          personnel le concernant, dans les conditions prévues par la
          Réglementation. Il peut exercer ses droits par courriel à l’adresse : 
        </p>
      </div>
    </div>

    <div class="proprietaire__dpo">
      <!-- <div class="proprietaire__dpo__titre">
        <p class="proprietaire__dpo__titre__description marginParagraphe font-bold">
          <span class="proprietaire__dpo__titre__description__adresse">
            DPO 12 rue du bois Guillaume, 91000 ÉVRY
          </span>
          <span class="proprietaire__dpo__titre__description__lieu">
            COURCOURONNES
          </span>
          <span class="proprietaire__dpo__titre__description__ou">
            ou par e-mail à 
          </span>
          <a href="mailto:dpo-sante@meilleurtaux.com" class="proprietaire__dpo__titre__description__link link-color">
            dpo-sante&#64;meilleurtaux.com
          </a>
        </p>
      </div> -->
      <div class="proprietaire__dpo__contenu font-bold marginParagraphe">
        <div class="proprietaire__dpo__contenu_adresse">
          DPO 95 rue d’Amsterdam, 75008 PARIS <br />
        </div>
        <!-- <div class="proprietaire__dpo__contenu__cour">
          COURCOURONNES
        </div> -->
        <div class="proprietaire__dpo__contenu__email">
          ou par e-mail à <a
            href="mailto:dpo-sante&#64;meilleurtaux.com"
            class="proprietaire__dpo__contenu__email__link link-color"
          >
            dpo-sante&#64;meilleurtaux.com
          </a>
        </div>
        <!-- <div class="proprietaire__dpo__contenu__link">
          <a href="mailto:dpo-sante@meilleurtaux.com" class="proprietaire__dpo__contenu__link__parent link-color">
            dpo-sante&#64;meilleurtaux.com
          </a>
        </div> -->
      </div>
    </div>

    <div class="proprietaire__accompagne">
      <p class="proprietaire__accompagne__titre marginParagraphe">
        Accompagné d’une copie de sa pièce d’identité afin de pouvoir justifier
        de son identité. 
      </p>

      <p class="proprietaire__accompagne__utilisateur marginParagraphe">
        L’Utilisateur peut également en cas de réclamation choisir de contacter
        la CNIL :
        <a
          href="https://www.cnil.fr/fr "
          target="_blank"
          class="proprietaire__accompagne__utilisateur__link link-color"
          >https://www.cnil.fr</a
        >
      </p>

      <p class="proprietaire__accompagne__autres_informations marginParagraphe">
        D’autres informations relatives à la protection des données personnelles
        sont disponibles en consultant la politique des donnée personnelles du
        groupe Meilleurtaux : 
        <a
          href="https://www.meilleurtaux.com/a-propos-de-meilleurtaux/mentions-legales.html#politique-donnee  "
          target="_blank"
          class="proprietaire__accompagne__autres_informations__link link-color"
          >https://www.meilleurtaux.com/a-propos-de-meilleurtaux/mentions-legales.html#politique-donnee</a
        >
      </p>
    </div>

    <div class="proprietaire__cookies">
      <p class="proprietaire__cookies_titre marginParagraphe font-bold">
        Cookies
      </p>

      <p class="proprietaire__cookies_description marginParagraphe">
        Un cookie est une information déposée sur votre ordinateur par les
        serveurs des sites que vous visitez. Les cookies sont un bloc de données
        utilisées par un serveur web pour envoyer des informations d’état au
        navigateur sur un utilisateur, et pour ce navigateur de renvoyer des
        informations d’état au serveur web d’origine.  Ils peuvent contenir
        plusieurs données, telles que le nom du serveur qui l’a déposé, un
        identifiant sous forme de numéro unique ou encore une date d’expiration
        par exemple. 
      </p>

      <p class="proprietaire__cookies_utilisation marginParagraphe">
        Les cookies utilisés par le site Mutuelle.com sont destinés à nous
        permettre de mesurer l’audience, l’utilisation ainsi que les
        performances de nos sites afin d’établir des statistiques anonymisées
        ainsi que des volumes de fréquentation.  Le stockage de cookies est
        subordonné à votre accord ou à votre défaut d’opposition. Cependant,
        vous avez la possibilité de manifester votre refus à tout moment en
        paramétrant votre navigateur internet. 
      </p>
    </div>

    <div class="proprietaire__loi">
      <p class="proprietaire__loi_titre marginParagraphe font-bold">
        Loi applicable et attribution de juridiction 
      </p>

      <p class="proprietaire__loi_description marginParagraphe">
        Le contenu de ce site est régi par la loi française. Tout litige qui
        surviendrait concernant l’interprétation ou l’exécution du présent site
        devra faire l’objet d’une tentative de règlement à l’amiable. Dans
        l’hypothèse où cette tentative s’avérerait infructueuse, le litige sera
        porté devant le tribunal compétent.
      </p>
    </div>
  </div>
</div>

<wz-footer-demande-devis></wz-footer-demande-devis>
